export var now = function now() {
  return new Date().getTime();
};